/**
 * The reader of `requires` (`src/features/manifest.ts`), ADR 9014.
 *
 * One gate is used for a chapter route whose manifest declares `requires` and for a shell route
 * that states the same type (`RouteRequires`). A person without the grant sees G2 §2.6's designed
 * no-permission state, the one `ProblemNotice` renders for a 401/403. They do not see a bespoke
 * 403 page or a screen of refused reads.
 *
 * Navigation, not security (G3.1). See `src/auth/grants.ts`.
 */

import type { ReactNode } from 'react';

import { hasGrants, useAccessGrants } from '../../auth/grants';
import type { RouteRequires } from '../../features/manifest';
import { EmptyState } from '../../primitives';

export function RequiresGate({ requires, children }: {
  readonly requires: RouteRequires | undefined;
  readonly children: ReactNode;
}): React.JSX.Element {
  const grants = useAccessGrants();
  if (!hasGrants(requires, grants.realmRoles)) {
    return <EmptyState variant="no-permission" titleKey="state.noPermission.title" bodyKey="state.noPermission.body" />;
  }
  return <>{children}</>;
}
